var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
let UpdatorService = class UpdatorService {
    constructor() {
        this.shouldReload = false;
    }
    /**
     * Перезагрузить страницу
     */
    pageReload() {
        window.location.reload();
    }
    /**
     * Обновить версию приложения, если новая отличается от сохраненной ранее
     * @param version - Новая версия
     */
    updateVersion(version) {
        if (version) {
            if (this.version) {
                if (this.version !== version) {
                    this.version = version;
                    this.shouldReload = true;
                }
            }
            else {
                this.version = version;
            }
        }
    }
    /**
     * Проверить необходимо ли перезагрузить приложение, и в случае необходимости выполнить перезагрузку
     * */
    run() {
        if (this.shouldReload) {
            this.shouldReload = false;
            this.pageReload();
        }
    }
};
UpdatorService = __decorate([
    injectable()
], UpdatorService);
export { UpdatorService };
